const sortAltUp = ({ color, type }) => {
  const regular = (
    <svg
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7739 9.00009H1.22694C0.363944 9.00009 -0.0940559 7.98009 0.478944 7.33509L6.25394 0.840094C6.34759 0.734399 6.46259 0.649779 6.59136 0.591826C6.72013 0.533873 6.85974 0.503906 7.00095 0.503906C7.14216 0.503906 7.28176 0.533873 7.41053 0.591826C7.5393 0.649779 7.6543 0.734399 7.74795 0.840094L13.5209 7.33509C14.0939 7.98009 13.6359 9.00009 12.7739 9.00009Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default sortAltUp;
